import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, authLoading, role } = useAuth();

  if (authLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  const roles = (role || '').split(',').map(s => s.trim().toUpperCase());
  if (!roles.includes('ADMIN')) return <Navigate to="/" replace />;

  return children;
};

export default AdminRoute;
